import React, { useEffect, useState } from "react";
import { ToothZapFooter } from "../layouts/footer";
import { Nav } from "../layouts/header";
import "../style/findadentiststyle.css";

interface Dentist {
  id: string;
  name: string;
  phone: string;
  area: string;
  bookingUrl: string;
}

const geoFaqs = [
  {
    question: "How do I find a ToothZap dentist near my area in New Delhi?",
    answer:
      "Use the search and area filter to browse verified ToothZap network clinics by locality, dentist name, or clinic name across New Delhi.",
  },
  {
    question:
      "Are all clinics listed on ToothZap verified for same-day crown delivery?",
    answer:
      "Yes. Every dentist shown here is a verified ToothZap network partner and each crown comes with a warranty card.",
  },
  {
    question: "Can I book directly with a clinic listed on ToothZap?",
    answer:
      "Yes. Each clinic card links directly to that dentist’s booking page so patients can book with the selected practice.",
  },
];

export const Findadendtist: React.FC = () => {
  const [dentists, setDentists] = useState<Dentist[]>([]);
  const [search, setSearch] = useState("");
  const [area, setArea] = useState("All areas");


  const [openIndex, setOpenIndex] = useState<number | null>(null);

  useEffect(() => {
    const mockData: Dentist[] = [];
    setDentists(mockData);
  }, []);

  return (
    <div>
      <Nav />

      {/* HERO SECTION */}
      <section className="container tz-container">
        <div className="row align-items-center">
          <div className="col-md-12 col-sm-12 col-lg-9">
            <h1 className="find-a-dentist-offering">
              Find a Dentist Offering Same-Day Crowns in New Delhi
            </h1>
            <p className="search-verified">
              Search verified ToothZap clinics by dentist, clinic name, or Delhi
              area to find a same-day <br /> crown partner near you.
            </p>
          </div>

          <div className="col-md-12 col-sm-12 col-lg-3">
            <input
              type="text"
              placeholder="Search dentist or clinic"
              className="search-dentist-or-clinic form-control mb-3"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />

            <select
              className="form-select search-dentist-or-clinic"
              value={area}
              onChange={(e) => setArea(e.target.value)}
            >
              <option>All areas</option>
              <option>Delhi</option>
              <option>Noida</option>
              <option>Gurgaon</option>
            </select>
          </div>
        </div>

     
        <div className="no-clinics-match col-md-12">
          No clinics match that search yet. Try a different Delhi area or clinic
          keyword.
        </div>
      </section>

  
      <section className="all-dentist-listed">
        <div className="container tz-container">
          <p className="mb-0 text-muted">
            All dentists listed are verified ToothZap network partners. Every
            crown comes with a warranty card.
          </p>
        </div>
      </section>


      <section className="container py-5">
        <div className="row">
          <div className="col-md-10 mx-auto">
            <h2 className="questions-patients">
              Questions patients ask before choosing a same-day crown clinic
            </h2>

            <div className="mt-4">
              {geoFaqs.map((faq, index) => (
                <details
                  key={index}
                  className="faq-section-infinddentist"
                  open={openIndex === index}
                >
                  <summary
                    className="faq-summary-custom"
                    onClick={(e) => {
                      e.preventDefault();
                      setOpenIndex(openIndex === index ? null : index);
                    }}
                  >
                    <span>{faq.question}</span>
                    <span className="faq-icon">
                      {openIndex === index ? "×" : "+"}
                    </span>
                  </summary>

                  <p className="faq-description">{faq.answer}</p>
                </details>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <ToothZapFooter />
    </div>
  );
};

export default Findadendtist;